export class ClsReferenciaModel {
  public REF_ID: number;

  public REF_CODIGO: string;

  public REF_DESCRIPCION: string;

  public REF_URLFOTO: string
}
